<template src="./template.html"></template>
<script>
import EventFlyer from 'components/EventFlyer'
import iframeLib from 'lib/iframe'
import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import config from 'src/config'
import iframeWidgetBaseMixin from 'mixins/iframeWidgetBase'

export default {
  name: 'event-flyer-widget',
  mixins: [iframeWidgetBaseMixin],
  data() {
    return {
      buttonBgColor: this.$route.query.buttonBgColor,
      buttonTextColor: this.$route.query.buttonTextColor,
      buttonText: this.$route.query.buttonText,
      attributionId: this.$route.query.attributionId,
      trackingId: this.$route.query.trackingId,
      theme: this.$route.query.theme,
      eventId: this.$route.query.eventId,
    }
  },
  methods: {
    onUpdated() {
      this.publishDimensions()
    },
    onEventClicked(event) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type: IFRAME_MESSAGE_TYPES.EVENT_CLICKED,
          iframeId: this.iframeId,
          data: {
            venueId: event.venue.id,
            event,
            eventId: event.id,
            attributionId: this.attributionId,
            trackingId: this.trackingId,
          },
        },
        {
          parent: true,
        }
      )
    },
  },
  components: {
    EventFlyer,
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Widgets/EventFlyer/index.vue